import {email, helpers, required} from "@vuelidate/validators";

export class ConsumerComplaintPatientModel {
    constructor(data = {}) {
        this.patientId = data.patientId ?? null;
        this.complaintId = data.complaintId ?? null;
        this.firstName = data.firstName ?? '';
        this.middleName = data.middleName ?? '';
        this.lastName = data.lastName ?? '';
        this.dob = data.dob ?? '';
        this.phoneNumber = data.phoneNumber ?? '';
        this.email = data.email ?? '';
        this.street = data.street ?? '';
        this.city = data.city ?? '';
        this.state = data.state ?? '';
        this.zipCode = data.zipCode ?? '';
        this.relationshipToPatient = data.relationshipToPatient ?? '';
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }

    static getValidationRules() {
        return {
            firstName: {required: helpers.withMessage('Consumer Complaint - Patient First Name is required', required)},
            lastName: {required: helpers.withMessage('Consumer Complaint - Patient Last Name is required', required)},
            dob: {required: helpers.withMessage('Consumer Complaint - Patient Date of Birth is required', required)},
            email: {email: helpers.withMessage('Consumer Complaint - Invalid email address', email)},
            street: {required: helpers.withMessage('Consumer Complaint - Street is required', required)},
            city: {required: helpers.withMessage('Consumer Complaint - City is required', required)},
            state: {required: helpers.withMessage('Consumer Complaint - State is required', required)},
            zipCode: {required: helpers.withMessage('Consumer Complaint - Zip Code is required', required)},
            relationshipToPatient: {required: helpers.withMessage('Consumer Complaint - Relationship to Patient is required', required)},
        };
    }
}
